import Icon from 'veui/components/Icon'
import { IconSortAsc } from 'dls-icons-vue'

Icon.register('sort-asc', IconSortAsc)
